<script lang="ts">
  import type { Snippet } from "svelte";
  import { jsonStorage } from "../stores/storage";

  let { viewerUrl, children } : { viewerUrl: string; children?: Snippet } = $props()
  const key = `pdfIframe-${Math.floor((Math.random() * 9999999))}`
  const height = jsonStorage(key, 100, {storage: sessionStorage})
</script>
{#if $height < 150}{@render children?.()}{/if}
<iframe title="PDF" src="{viewerUrl}?heightKey={key}" style="height: {$height}px;" class="w-full border-none"></iframe>
